import * as e from "react";
const m = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zm4.4 13.7l-1.2 1.2L12 13l-3.2 3.3-1.2-1.2L11 12 7.6 8.8l1.2-1.2L12 11l3.2-3.3 1.2 1.2L13 12l3.3 3.2z" }));
export {
  m as ReactComponent
};
